import { Chip } from "@mui/material"
import type { ColumnDef } from "@tanstack/react-table"

import FileChip from "@/components/upload/components/display/FileChip"
import type { SignedUrl } from "@/graphql/codegen/graphql"
import { GoodsReceiptUploadsRowActions } from "@/screens/WarehouseReceiving/components/GoodsReceiptUploads/GoodsReceiptFileTable/GoodsReceiptUploadsRowActions"
import { FILE_TYPE_MAPPING } from "@/screens/WarehouseReceiving/constants"
import type { GoodsReceiptFileType } from "@/screens/WarehouseReceiving/types"

const fileTypeChipContent = (fileFieldGroup: GoodsReceiptFileType) => {
  const chipInfo = FILE_TYPE_MAPPING[fileFieldGroup]
  return (
    <Chip
      className='mr-2 rounded-full'
      sx={{
        backgroundColor: chipInfo.color,
      }}
      label={chipInfo.label ?? "-"}
    />
  )
}

export const useGoodsReceiptFileColumns = (onRemove: (fileId: string) => Promise<boolean>): ColumnDef<SignedUrl>[] => {
  return [
    {
      accessorKey: "fileType",
      header: "Type",
      enableSorting: true,
      sortingFn: "alphanumeric",
      size: 100,
      cell: ({ row }) => fileTypeChipContent(row.original.file?.fieldGroup as GoodsReceiptFileType),
    },
    {
      accessorKey: "file",
      header: "File",
      size: 150,
      enableSorting: false,
      sortingFn: "alphanumeric",
      cell: ({ row }) => <FileChip file={row.original} showExtension={true} />,
    },
    {
      accessorKey: "description",
      header: "Description",
      size: 300,
      enableSorting: false,
      sortingFn: "alphanumeric",
      cell: ({ row }) => {
        return row.original.file?.label || "-"
      },
    },
    {
      accessorKey: "actions",
      header: "",
      enableSorting: false,
      size: 72,
      cell: ({ row }) => <GoodsReceiptUploadsRowActions row={row} onRemove={onRemove} />,
    },
  ]
}
